export { default } from './PageEvents.vue'
